import { addLocaleData } from 'react-intl';
import ja from 'react-intl/locale-data/ja';
import navLocaleData from '@99designs/common/apps/global-nav/locale-data/ja';
import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(ja);



// WEBPACK FOOTER //
// ./src/js/locale-data/ja.js